import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { Store } from '@ngxs/store';
import { BusinessDispatch, BusinessState } from '@state/business';
import { ContentHeaderTitleImg } from 'src/app/ui/content-header/content-header.component';
import { BaseBusinessSettingsSection } from '../business-finances-general/common/base-business-settings-section/base-business-settings-section.directive';
import { TestHooks } from './title-search-settings.hooks';

@Component({
	selector: 'app-title-search-settings',
	templateUrl: './title-search-settings.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitleSearchSettingsComponent extends BaseBusinessSettingsSection {
	testHooks = TestHooks;
	private businessDispatch = inject(BusinessDispatch);
	private store = inject(Store);

	public settings = this.store.selectSignal(
		BusinessState.getDefaultTitleSearchFeeSettings,
	);
	public ICON = ICON;
	public titleImgConfig: ContentHeaderTitleImg = {
		imgSrc: 'assets/images/emails/invite/integration-pngs/teranet.png',
		altText: 'Title Search',
	};

	currentDirectionOfFee = computed(() => {
		return this.settings()?.location || DirectionOfFeeType.SOA;
	});

	public directionOfFeeType = DirectionOfFeeType;

	setCombineTitleAndWrits(value: boolean) {
		this.toggleSetting(value, 'combineTitleAndWritsFees');
	}

	setApplyHstAll(value: boolean): void {
		this.toggleSetting(value, 'applyHstAll');
	}

	private toggleSetting(
		value: boolean,
		field: 'combineTitleAndWritsFees' | 'applyHstAll',
	) {
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.titleSearch.feeSettings.${field}`,
			value,
		);
	}
}
